/**
 * Los dos estados que toda vista que pide datos tiene que saber mostrar.
 *
 * Estan aca para que ninguna pantalla resuelva a su manera "esta cargando" o
 * "se cayo la API", y para que el mensaje de error diga algo util en vez de
 * "Error 500".
 */
import type { ErrorApi } from '../../tipos/api';
import { Icono } from './Icono';

export function Cargando({ que }: { que: string }) {
  return (
    <p className="cargando" role="status">
      Cargando {que}…
    </p>
  );
}

export function AvisoError({ error }: { error: ErrorApi | null }) {
  return (
    <div className="vacio" role="alert">
      <span className="vacio-icono">
        <Icono nombre="alerta" />
      </span>
      <h2>No pudimos cargar esta pagina</h2>
      <p>{error?.mensaje ?? 'Revisa tu conexion e intenta de nuevo en unos minutos.'}</p>
    </div>
  );
}
